import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from './rootReducer';

const logger = createLogger({
    collapsed: true
});
const middlewares = [...getDefaultMiddleware()];
const store = configureStore({
    reducer: rootReducer,
    middleware: middlewares,
});

export default store;
